import { InjectionToken } from '@angular/core';
export interface FeatureFlags {
  wattFeatureEnable: boolean
}

export const FEATURE_FLAGS = new InjectionToken<FeatureFlags>('FeatureFlags');
